import type { AxiosResponse, RequestOptions } from '@@/plugin-request/request';
import { request as umiRequest } from 'umi';
import { isUrl } from '@/utils';

interface IRequestOptions extends RequestOptions {
  /**
   * restfulParams restful参数
   */
  restfulParams?: Record<string, any>;
}

interface IRequestOptionsWithResponse extends IRequestOptions {
  getResponse: true;
}

interface IRequestOptionsWithoutResponse extends IRequestOptions {
  getResponse: false;
}

interface IRequest {
  <T = any>(opts: IRequestOptionsWithResponse): Promise<AxiosResponse<T>>;
  <T = any>(opts: IRequestOptionsWithoutResponse): Promise<T>;
  <T = any>(opts: IRequestOptions): Promise<T>; // getResponse 默认是 false， 因此不提供该参数时，只返回 data
}

const request: IRequest = (config) => {
  const { url = '', baseURL, restfulParams, ...rest } = config;
  let urlPath = url;

  // restful转换
  if (restfulParams) {
    Object.keys(restfulParams).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(restfulParams, key)) {
        urlPath = urlPath.replace(
          `{${key}}`,
          encodeURIComponent(restfulParams[key]),
        );
      }
    });
  }
  return umiRequest(urlPath, {
    timeout: 0,
    // http(s)
    baseURL: isUrl(urlPath) ? '' : baseURL,
    // 透传axios参数
    // https://axios-http.com/zh/docs/req_config
    ...rest,
  });
};

export default request;
